import { render, staticRenderFns } from "./ExpirationWarning.vue?vue&type=template&id=2bf12bb5&"
import script from "./ExpirationWarning.vue?vue&type=script&lang=js&"
export * from "./ExpirationWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports